import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthService } from '../../../api/services/auth.service';
import { HeaderNavComponent } from 'src/app/ui/header-nav/header-nav.component';
import { FooterComponent } from 'src/app/ui/footer/footer.component';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, RouterModule,
    MatCardModule, MatFormFieldModule, MatInputModule,
    MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatSnackBarModule,
    HeaderNavComponent, FooterComponent
  ],
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent {
  form: FormGroup;
  loading = false;
  hideOld = true;
  hideNew = true;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8)]]
    });
  }

  submit(): void {
    if (this.form.invalid) return;
    this.loading = true;
    this.auth.changePassword(this.form.value).subscribe({
      next: () => {
        this.loading = false;
        this.snackBar.open('Password changed successfully!', 'OK', { duration: 5000 });
        this.form.reset();
      },
      error: (err) => {
        this.loading = false;
        const msg = err.error?.message || 'Failed to change password.';
        this.snackBar.open(msg, 'Close', { duration: 5000 });
      }
    });
  }

  onBack(): void {
    this.router.navigate(['/']);
  }
}
